window.console || (window.console = {
	log: function(){}
});
var FUNCTIONS = window.FUNCTIONS || null;
var cssua = window.cssua || null;

(function($){
	const htmlHasClass = (_class) => {
		return $('html').hasClass(_class);
	};
	const siteName = '';
	const a = 'is-active';
	const v = 'is-visible';
	const f = 'is-fixed';
	const slideSpeed = '400';

	FUNCTIONS = {
		va: {
			pathname: location.pathname,
			isMobile: htmlHasClass('ua-mobile'),
			device: {
				desktop: 1024,
				sp: 768
			},
			window: {
				width: $(window).width(),
				height: $(window).height()
			}
		},
		localDecision(){
			var regExp = new RegExp(`(test\\.${siteName}\\.connecty\\.co\\.jp|copre\\.jp|localhost|192\\.168\\.)`, 'g');
			return regExp.test(location.hostname);
		},
		localLoading(){
			let _this = this;
			// ローカル環境ならincludeをAjaxで読み込む
			let key = 'inc_';
			let ajaxArray = [];
			let ajaxArrayList = [];
			let includeClass = document.querySelectorAll(`[class*="${key}"]`);
			let includeClassLen = includeClass.length;

			for (let i=0; i < includeClassLen; i++) {
				var path = includeClass[i].innerHTML.split(' ')[1];
				ajaxArray.push(path);
			}
			var ajaxLen = ajaxArray.length;

			if (ajaxLen > 0) {
				for (let i=0; i < ajaxLen; i++) {
					ajaxArrayList[i] = $.ajax({
						type: 'GET',
						url: ajaxArray[i] + '.html',
						dataType: 'html',
						timeout: 5000
					});
				}
				$.when.apply($, ajaxArrayList).done((...args) => {
					let regExp = new RegExp(key);

					if (args[1] === 'success') { // includeが1個だけの場合
						let position = $(args[0]).filter(':first').attr('class').split(' ');
						for (let j = 0; j < position.length; j++) {
							if (position[j].match(regExp)) {
								position = position[j];
								break;
							}
						}
						$('.' + position).html(args[0]).children().unwrap();

						console.log('Succeeded to read the include file!:', position);
					} else {
						for (let i=0; i < args.length; i++) {
							let result = args[i];
							let position = $(result[0]).filter(':first').attr('class').split(' ');

							for (let j=0; j < position.length; j++) {
								if (position[j].match(regExp)) {
									position = position[j];
									break;
								}
							}
							$('.' + position).html(result[0]).children().unwrap();

							console.log('Succeeded to read the include file!:', position);
						}
					}
					_this.loadDelayScript();
				});
			} else {
				_this.loadDelayScript();
			}
		},
		catchAjaxError(_errorThrown){
			if(window.ga) {
				window.ga('send', 'event', 'ajaxError', location.href, _errorThrown, 0, true);
			}
		},
		getQuery(){
			var vars = [];
			var hash = null;
			var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
			for(var i = 0; i < hashes.length; i++) {
				hash = hashes[i].split('=');
				vars.push(hash[0]);
				vars[hash[0]] = hash[1];
			}
			return vars;
		},
		nextToggle(){
			var $switch = $('.js-toggle');

			$switch.on('click', function(){
				$(this).toggleClass(a);
				$(this).next('.js-toggleBlock').stop().slideToggle(slideSpeed);
			});
		},
		easeScroll(){
			$('a[rel="scroll"]').on('click', (event) => {
				if(/#/.test(event.currentTarget.href)) {
					var speed = 1200;
					scrollToObject(event, speed);
					return false;
				}
			});
			function scrollToObject(_self, _speed){
				var hash = '#' + _self.currentTarget.href.split('#')[1];
				var pos = hash === '#pagetop' ? 0 : $(hash).offset().top;

				if(hash !== '#pagetop') {
					if(FUNCTIONS.va.window.width < FUNCTIONS.va.device.sp) {
						pos -= 80;
					} else {
						pos -= 100;
					}
				}

				// $('html,body').stop().animate({ scrollTop: pos }, _speed, 'easeOutExpo');
				// lazyloadとの併用のための記述
				$.when(
					$('html, body').animate({
						scrollTop: pos
					}, _speed, 'easeOutExpo'),
					// _self.preventDefault(),
				).done(function() {
					if(hash !== '#pagetop') {
						var diff = $(hash).offset().top;
						if(FUNCTIONS.va.window.width < FUNCTIONS.va.device.sp) {
							diff -= 80;
						} else {
							diff -= 100;
						}
						if(diff !== pos) {
							$('html, body').animate({
								scrollTop: diff
							}, 10, 'easeOutExpo');
						}
					}
				});
			}
		},
		easeScrollHash() {
			const hash = location.hash;
			if (hash) {
				$(window).on('load', () => {
					$('html, body').css('display', 'none');

					setTimeout(() => {
						$('html, body').css('display', 'block');

						let _hash = '#' + hash.split('#')[1];
						let pos = $(_hash).offset().top;

						if (FUNCTIONS.va.window.width < FUNCTIONS.va.device.sp) {
							pos -= 60;
						} else {
							pos -= 100;
						}
						$('html, body').stop().animate({ scrollTop: pos }, 1200, 'easeOutExpo');
					}, 100);
				});
			}
		},
		tabSwitch() {
			let $tab = $('.js-tab');
			let $content = $('.js-tab-content');
			if ($('.js-tab').length) {
				let locHash = location.hash;
				if (locHash.length > 0) {
					let href = locHash.split('#')[1];

					$tab.each((idx, ele) => {
						$(ele).removeClass(a);
						let dataSwitch = $(ele).attr('data-target');

						if (dataSwitch.match(href)) {
							$(ele).addClass(a);
						}
					});

					$content.each((idx, ele) => {
						$(ele).removeClass(a).removeClass(v);
						let dataTarget = $(ele).attr('data-target');

						if (dataTarget.match(href)) {
							$(ele).addClass(a);
							setTimeout(() => {
								$(ele).addClass(v);
							}, '200');
						}
					});
				}

				$tab.on('click', (e) => {
					$(e.currentTarget).addClass(a);
					$tab.each((idx, ele) => {
						$(ele).removeClass(a);
					});
					$content.each((idx, ele) => {
						$(ele).removeClass(a).removeClass(v);
					});

					let $switch;
					if ($(e.currentTarget).attr('data-target') === 'all') {
						$switch = $content;
					} else {
						$switch = $('[data-target=' + $(e.currentTarget).attr('data-target') + ']');
					}
					$switch.addClass(a);
					setTimeout(() => {
						$switch.addClass(v);
					}, '200');
				});
			}
		},
		pageTop(){
			var $pagetop = $('.footer-pagetop');

			if (FUNCTIONS.va.window.width > 1024) {
				$(window).scroll(function(e){
					var $this = $(e.currentTarget);
					var $footer = $('.footer-bottom');
					var footerPos = $footer.offset().top + $footer.height();
					var thisScroll = $this.scrollTop();
					var pagetopPos = $this.height() + $footer.height() + thisScroll;

					if (thisScroll > '150') {
						$pagetop.addClass(v);
					} else {
						$pagetop.removeClass(v);
					}
					if (footerPos <= pagetopPos) {
						$pagetop.addClass('is-bottom');
					} else {
						$pagetop.removeClass('is-bottom');
					}
				});
			}
		},
		header() {
			const $header = $('.header');
			const $nav = $('.header-nav');
			const $overlay = $('.header-overlay');
			let scrollTopNow;

			// ハンバーガーメニュー
			const fixedOnContainer = () => {
				scrollTopNow = $(window).scrollTop();
				$('.container').css({
					position: 'fixed',
					width: '100%',
					top: -1 * scrollTopNow,
					left: 0
				});
				$('body').addClass(f);
			};
			const fixedOffContainer = () => {
				$('.container').css({
					position: 'static'
				});
				$('body').removeClass(f);
				$(window).scrollTop(scrollTopNow);
			};

			$('.header-hamburger').on('click', (e) => {
				$(e.currentTarget).toggleClass(a);
				if ($nav.hasClass(a)) {
					$nav.removeClass(v);
					$header.removeClass(a);
					$overlay.removeClass(v);
					setTimeout(() => {
						$nav.removeClass(a);
						$overlay.removeClass(a);
					}, 400);
					fixedOffContainer();
				} else {
					fixedOnContainer();
					$overlay.addClass(a);
					$header.addClass(a);
					$nav.addClass(a);
					setTimeout(() => {
						$overlay.addClass(v);
						$nav.addClass(v);
					});
				}
			});

			// スクロールで色・ロゴ変更
			$(window).scroll((e) => {
				let $this = $(e.currentTarget);
				let thisScroll = $this.scrollTop();
				if (thisScroll === 0) {
					$header.removeClass('is-scroll');
				} else {
					$header.addClass('is-scroll');
				}
			});

			// メガメニュー展開時 カテゴリホバーで下層リンク表示（PC）
			if (FUNCTIONS.va.window.width >= FUNCTIONS.va.device.desktop) {
				$('.header-nav-list').find('.__main').each((idx, ele) => {
					$(ele).mouseenter(() => {
						$('.header-nav-list').find('.__main').each((idx2, ele2) => {
							$(ele2).removeClass('is-hover');
							$(ele2).next('.__innerList').removeClass('is-hover');
						});

						$('.header-nav-list').addClass('is-hoverWrap');
						$(ele).addClass('is-hover');
						if ($(ele).hasClass('js-header-MenuHead')) {
							$(ele).next('.__innerList').addClass('is-hover');
						}
					});
				});
				$('.header-nav-list').mouseleave(() => {
					$('.header-nav-list').removeClass('is-hoverWrap');
					$('.header-nav-list').find('.__main').removeClass('is-hover');
					$('.header-nav-list').find('.__innerList').removeClass('is-hover');
				});
			} else {
				// モバイルはアコーディオン開閉
				$('.header-nav-list').find('.__main').each((idx, ele) => {
					$(ele).on('click', () => {
						if ($(ele).hasClass('js-header-MenuHead')) {
							if ($(ele).hasClass('is-hover')) {
								$(ele).removeClass('is-hover');
								$(ele).next('.__innerList').removeClass('is-hover');
								$(ele).next('.__innerList').stop().slideUp();
							} else {
								$(ele).addClass('is-hover');
								$(ele).next('.__innerList').addClass('is-hover');
								$(ele).next('.__innerList').stop().slideDown();
							}
							return false;
						}
					});
				});
			}

			// Lang切り替えプルダウン(モバイルのみ)
			if (FUNCTIONS.va.window.width < FUNCTIONS.va.device.desktop) {
				$('.header-sub .__lang span').on('click', (e) => {
					$('.header-sub .__lang').find('a').slideToggle();
				});
			}

			// サイト内検索窓
			$('.js-header-siteSearch').on('click', (e) => {
				$('.header-siteSearch').addClass(a);
				setTimeout(() => { $('.header-siteSearch').addClass(v); });
			});
			$('.js-header-siteSearch-close').on('click', (e) => {
				$('.header-siteSearch').removeClass(v);
				setTimeout(() => { $('.header-siteSearch').removeClass(a); }, 400);
			});

		},
		footer() {
			if (FUNCTIONS.va.window.width <= 1024) {
				$('.footer-nav .js-footer-spToggle').each((idx, ele) => {
					$(ele).on('click', () => {
						$(ele).toggleClass(a);
						$(ele).next('.js-footer-spToggleBlock').slideToggle();
						return false;
					});
				});
			}
		},
		modal(){
			$('.mod-modal').on('click', (e) => {
				let HTML = '<div class="mod-modal-overlay">';
				HTML +=
					'<div class="mod-modal-closeArea"></div>'+
					'<span class="mod-modal-closeBtn"><span></span></span>' +
					`${$(e.currentTarget).find('img').prop('outerHTML')}</div>`;
				$('body').append(HTML);
				const $overlay = $('.mod-modal-overlay');
				$overlay.addClass(a);
				setTimeout(() => {
					$overlay.addClass(v);
					$('.mod-modal-closeArea, .mod-modal-closeBtn').on('click', () => {
						$overlay.removeClass(v);
						setTimeout(() => {
							$overlay.removeClass(a);
							$overlay.remove();
						}, 400);
					});
				});
			});
		},
		spTableScroll(){
			if (FUNCTIONS.va.window.width < FUNCTIONS.va.device.desktop) {
				$('.mod-tblWrap').on('touchstart', (e) => {
					$(e.currentTarget).find('.__scroll').addClass('is-hidden');
				});
			}
		},
		graduateListSlider(){
			// $('.whatis-graduateList.__slider .__item').each((idx, ele) => {
			// 	if ($(ele).find('a').attr('href') === FUNCTIONS.va.pathname) {
			// 		$(ele).remove();
			// 	}
			// });
			$('.whatis-graduateList.__slider').slick({
				slidesToShow: 4,
				slidesToScroll: 1,
				speed: 500,
				infinite: true,
				dots: true,
				arrows: true,
				prevArrow: '<button type="button" class="slick-prev"><svg><use xlink:href="/common/svg/sprite.svg#arrow3" /></svg></button>',
				nextArrow: '<button type="button" class="slick-next"><svg><use xlink:href="/common/svg/sprite.svg#arrow3" /></svg></button>',
				responsive: [
					{
						breakpoint: 1024,
						settings: {
							slidesToShow: 2,
						}
					},
					{
						breakpoint: 640,
						settings: {
							slidesToShow: 1,
						}
					},
				]
			});
		},
		lazyload(){
			if($('.js-lazy-img').length) {
				$('.js-lazy-img').lazyload();
			}
		},
		magnificPopup () {
			$('.js-modalVideo').magnificPopup({
				type: 'iframe',
				mainClass: 'mfp-fade',
				removalDelay: 160,
				preloader: false,
				fixedContentPos: false
			});
		},
		loadDelayScript(){
			var _this = this;
			_this.nextToggle();
			_this.easeScroll();
			_this.easeScrollHash();
			_this.tabSwitch();
			_this.pageTop();
			_this.header();
			_this.footer();
			_this.modal();
			_this.spTableScroll();
			_this.lazyload();
			_this.magnificPopup();

			if ($('.whatis-graduate-detail').length) {
				_this.graduateListSlider();
			}
		}
	};

	$(() => FUNCTIONS.localDecision() ? FUNCTIONS.localLoading() : FUNCTIONS.loadDelayScript());
})(window.jQuery);
